import { Dialog as DialogPrimitive } from '@base-ui/react/dialog';
import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
export function Modal({ open, onOpenChange, title, description, children, wide = false }: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    description?: string;
    children: ReactNode;
    wide?: boolean;
}) {
    return <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}><DialogPrimitive.Portal>
  <DialogPrimitive.Backdrop className="modal-backdrop"/>
  <DialogPrimitive.Popup className={cn('modal-popup', wide && 'modal-wide')}>
   <div className="modal-heading"><div><DialogPrimitive.Title className="modal-title">{title}</DialogPrimitive.Title>{description && <DialogPrimitive.Description className="modal-description">{description}</DialogPrimitive.Description>}</div>
   <DialogPrimitive.Close className="icon-button" aria-label="Close dialog"><X size={18}/></DialogPrimitive.Close></div>
   {children}
  </DialogPrimitive.Popup>
 </DialogPrimitive.Portal></DialogPrimitive.Root>;
}
